import { Typography } from '@components/style';
import { theme } from '@theme';
import { FC } from 'react';
import styled from 'styled-components';

type ErrorPageProps = {
  isFailed: boolean;
  title?: string;
  description?: string;
};

const ErrorPage: FC<ErrorPageProps> = ({ isFailed, title, description }) => {
  return (
    <Wrapper data-testid='error-page' hidden={!isFailed}>
      <Typography
        size={theme.typography.h2}
        marginLeft={5}
        display={'block'}
        paddingBottom={5}
        fontWeight={theme.typography.fontWeights.semibold}
        color={theme.palette.basicGray}
      >
        {title}
      </Typography>
      <Typography
        size={theme.typography.h4}
        marginLeft={5}
        display={'block'}
        color={theme.palette.dusty}
      >
        {description}
      </Typography>
    </Wrapper>
  );
};

export default ErrorPage;

const Wrapper = styled.div`
  position: fixed;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 99;
  text-align: center;
  padding-top: 300px;
`;
